
import VueMethods from "@/vue-methods";
import Multiselect from "vue-multiselect";
import { Component, Prop, Vue } from "vue-property-decorator";
import IconFilter from "../common/icon/IconFilter.vue";
import { EReportStatus, EReportType, IReportRequest } from "@/services/backend/report";
import { ICountry, IUser } from "@/entities";
import { EUserType, IPageResponse } from "@/services";
import { Getter } from "vuex-class";
import { EventBus } from "@/event-bus";
import { Locale } from "@/store";

@Component({
  components: {
    IconFilter,
    Multiselect,
  },
  mixins: [VueMethods],
})
export default class FilterReports extends Vue {
  @Prop({ required: false, default: null }) params!: IReportRequest;
  @Getter("getLocale") locale!: Locale;
  @Getter("getLoggedUser") loggedUser: IUser | undefined;
  @Getter("getCountriesPage") countriesPage: IPageResponse<ICountry> | undefined;

  public userTypeProsegur = EUserType.PROSEGUR;
  public option = null;
  public visible = false;
  public visibleUsername = true;
  public userTypeOptions = Object.values(EUserType);
  public reportTypeOptions = Object.values(EReportType);
  public statusOptions = Object.values(EReportStatus);
  public paramsEdit: IReportRequest = Object.assign({}, this.params);

  get countrySelected(): ICountry | undefined {
    return this.optionsCountries?.find((option) => option.id === this.paramsEdit.countryId);
  }

  set countrySelected(value: ICountry | undefined) {
    this.paramsEdit.countryId = value?.id;
  }

  get usernameSelected(): IUser | undefined {
    return this.optionsCountries?.find((option) => option.id === this.paramsEdit.countryId);
  }

  set usernameSelected(value: IUser | undefined) {
    this.paramsEdit.countryId = value?.id;
  }

  get optionsCountries(): ICountry[] {
    if (this.$ability.can("read", "Countries")) {
      return this.countriesPage?.content || [];
    } else if (this.loggedUser?.country?.id) {
      this.paramsEdit.countryId = undefined;

      return (
        this.countriesPage?.content.filter(
          (country) => this.loggedUser?.country?.id === country.id
        ) || []
      );
    }
    return [];
  }

  get optionReports(): EReportType[] {
    return this.reportTypeOptions
      .filter((value) => {
        switch (value) {
          case EReportType.ORDERS:
            return this.$ability.can("read", "OrdersPage");
          case EReportType.USERS:
            return this.$ability.can("read", "UsersPage");
          case EReportType.EMPLOYEE_SEARCH:
            return this.$ability.can("read", "FirmsPage");
          case EReportType.SUBCLIENT:
            return this.$ability.can("read", "SubclientsPage");
          case EReportType.SERVICE_POINT:
            return this.$ability.can("read", "ServicepointsPage");
          case EReportType.CLIENT:
            return this.$ability.can("read", "ClientsPage");
          case EReportType.ORDER_APPROVALS:
            return this.$ability.can("read", "ApprovalsPage");
          default:
            return true;
        }
      })
      .sort((a, b) =>
        this.$t(`option.type.${a.toLowerCase()}`)
          .toString()
          .localeCompare(this.$t(`option.type.${b.toLowerCase()}`).toString(), this.locale, {
            sensitivity: "base",
          })
      );
  }

  get filterLength(): number {
    let length = 0;
    Object.entries(this.params).forEach(([key, value]) => {
      if (
        value &&
        key !== "active" &&
        key !== "direction" &&
        key !== "orderBy" &&
        key !== "page" &&
        key !== "size"
      ) {
        length++;
      }
    });
    return length;
  }

  doCleanUp(): void {
    Object.keys(this.paramsEdit).forEach((key) => {
      (this.paramsEdit as any)[key] = undefined;
    });

    this.$emit("update:params", Object.assign({}, this.paramsEdit));
    EventBus.$emit("update-reports-table");
  }

  doFilter(): void {
    this.$emit("update:params", Object.assign({}, this.cleanUpEmptyStrings(this.paramsEdit)));
    EventBus.$emit("update-reports-table");
    this.visible = false;
  }
}
